import Component from "~/route-containers/partner/wholesale.container";
import { wholesaleLoader } from "~/loaders/wholesale.loader";
import { MetaFunction } from "@remix-run/node";
export { wholesaleLoader as loader };

export const meta: MetaFunction = ({ matches, data }) => {
  const parentsData = matches[0]?.data;
  const storeMetadata = parentsData?.storeMetadata;
  const enterpriseName = storeMetadata?.enterpriseName || "";
  const country = storeMetadata?.country || "";
  const city = storeMetadata?.storeCity || "";
  const title = `${data?.title
    ?.replace("{{enterpriseName}}", city)
    ?.replace("{{city}}", city)} ${country}`;
  const descriptionWholesale = `${data?.descriptionWholesale?.replace(
    "{{enterpriseName}}",
    enterpriseName,
  )} ${city}`;
  return [
    { name: "charset", content: "utf-8" },
    { title: title },
    {
      name: "viewport",
      content: "width=device-width,initial-scale=1,maximum-scale=1",
    },
    { name: "og:title", content: title },
    { name: "og:description", content: descriptionWholesale },
  ];
};

export default Component;
